/* istanbul ignore file */

export default ({ palette }) => ({
  backgroundCard: palette.colors.white,
  backgroundOverlay: 'rgba(0,0,0,0.25)',
  borderColor: palette.colors.silver,
  borderRadius: 5,
  btnCloseBackground: palette.colors.gallery,
  cardDropShadow: { boxShadow: '0px 2px 6px rgba(0,0,0,0.2)' },
  cardWidth: 500,
  gripColor: palette.colors.mineShaft,
  textColor: palette.colors.mineShaft,
  icon: {
    position: 'absolute',
    top: 28,
    topWithHeader: 32,
    topWithSecondaryHeader: 21,
    left: 34
  },
  errorModal: {
    borderLeftColor: palette.colors.red,
    '& $icon svg': {
      fill: palette.colors.red,
      width: 24,
      height: 24
    }
  },
  warningModal: {
    borderLeftColor: palette.colors.yellowOrange,
    '& $icon svg': {
      fill: palette.colors.yellowOrange,
      width: 24,
      height: 24
    }
  },
  successModal: {
    borderLeftColor: palette.colors.emerald,
    '& $icon svg': {
      fill: palette.colors.emerald,
      width: 24,
      height: 24
    }
  },
  infoModal: {
    borderLeftColor: palette.colors.dodgerBlue,
    '& $icon svg': {
      fill: palette.colors.dodgerBlue,
      width: 24,
      height: 24
    }
  },
  card: {
    '&$hasType': {
      borderLeftWidth: 6,
      padding: '30px 40px 30px 74px'
    },
    borderLeftStyle: 'solid',
    borderLeftWidth: 0,
    padding: '30px 40px'
  },
  content: {
    maxHeight: ({ maxContentHeight }) => maxContentHeight,
    noHeaderPadding: '0px 40px 0px 0px'
  },
  header: {
    '&$hasSecondaryHeader': {
      padding: '18px 80px 14px 40px',
      margin: '-30px -40px 30px -40px',
      borderBottom: `1px solid ${palette.colors.silver}`
    },
    padding: '0 40px 0 0',
    margin: 0,
    borderBottom: 0,
    color: palette.colors.mineShaft
  },
  primaryHeader: {
    '&$hasSecondaryHeader': {
      marginBottom: 0
    },
    lineHeight: '26px',
    fontSize: 20,
    maxWidth: '100%',
    overflow: 'hidden',
    display: 'inline-block',
    marginBottom: 20,
    marginRight: 20,
    marginTop: 0
  },
  secondaryHeader: {
    fontSize: 20,
    lineHeight: '26px',
    maxWidth: '100%',
    overflow: 'hidden',
    display: 'inline-block',
    color: palette.colors.doveGray,
    marginBottom: 0
  },
  secondaryHeaderDivider: {
    width: 1,
    height: 28,
    margin: [0, 20, 0, 0],
    background: palette.colors.silver,
    display: 'inline-block'
  },
  takeover: {
    padding: '30px 7%'
  },
  btnClose: {
    '&$hasSecondaryHeader': {
      margin: '15px 26px'
    },
    background: 'transparent',
    position: 'absolute',
    right: 0,
    top: 0,
    width: 44,
    height: 40,
    border: 0,
    cursor: 'pointer',
    margin: '22px 26px',
    '& svg': { fill: palette.colors.mineShaft },
    '&:hover': {
      '& svg': { fill: palette.colors.lochmara }
    }
  }
});
